import { FC } from 'react'
import Accordion from './Accordion'
import { virtualOfficeStrings } from 'common/strings/virtual-office-strings' // we need this to make JSX compile
import { Tenant } from 'common/tenant'

type WhyChooseType = {
  isForward?: boolean
  tenant?: Tenant
}

const WhyChoose: FC<WhyChooseType> = ({ isForward, tenant = Tenant.UK }) => {
  const au = tenant === Tenant.AU
  return (
    <Accordion
      headerSize={3}
      expandAllButton={true}
      expandAllButtonDesktopOnly={true}
      items={[
        {
          body: (
            <div
              dangerouslySetInnerHTML={{
                __html: virtualOfficeStrings.safeCancellingDescription,
              }}
            />
          ),
          title: virtualOfficeStrings.safeCancelling,
        },
        {
          body: (
            <div
              dangerouslySetInnerHTML={{
                __html: au
                  ? virtualOfficeStrings.topQualityPostCodeAuDescription
                  : virtualOfficeStrings.topQualityPostCodeDescription,
              }}
            />
          ),
          title: virtualOfficeStrings.topQualityPostCode,
        },
        {
          body: (
            <div
              dangerouslySetInnerHTML={{
                __html: au
                  ? virtualOfficeStrings.asicRegisteredAddressAuDescription
                  : virtualOfficeStrings.companiesHouseRegisteredAddressDescription,
              }}
            />
          ),
          title: au
            ? virtualOfficeStrings.asicRegisteredAddressAu
            : virtualOfficeStrings.companiesHouseRegisteredAddress,
        },
        isForward
          ? {
              body: (
                <div>
                  We include the first 40 items of post each month free of
                  charge, covering 99.9% of our customers' needs. Should you
                  exceed this amount, our overage fees schedule applies.
                </div>
              ),
              title: 'Generous Free Post Handling Included',
            }
          : null,
        au
          ? null
          : {
              body: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: virtualOfficeStrings.legalAddressForHMRCDescription,
                  }}
                />
              ),
              title: virtualOfficeStrings.legalAddressForHMRC,
            },
        {
          body: (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  virtualOfficeStrings.receiveYourBusinessLettersDescription,
              }}
            />
          ),
          title: virtualOfficeStrings.receiveYourBusinessLetters,
        },
        {
          body: (
            <div
              dangerouslySetInnerHTML={{
                __html: virtualOfficeStrings.averageSetupTimeDescription,
              }}
            />
          ),
          title: virtualOfficeStrings.averageSetupTime,
        },
        {
          body: (
            <div
              dangerouslySetInnerHTML={{
                __html: virtualOfficeStrings.emailAlertsDescription,
              }}
            />
          ),
          title: virtualOfficeStrings.emailAlerts,
        },
      ].filter((v) => !!v)}
    />
  )
}

export default WhyChoose
